var _rect, _rect2, _rect3, _g, _rect4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutsec31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 28.5,
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 76,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BFEEF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 62,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#FFE5C0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_6059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0703 54H54.9297C53.3143 54 52 55.3143 52 56.9297V95.9922C52 97.6076 53.3143 98.9219 54.9297 98.9219H65.7939C66.3332 98.9219 66.7705 98.4846 66.7705 97.9453C66.7705 97.4061 66.3332 96.9688 65.7939 96.9688H54.9297C54.3912 96.9688 53.9531 96.5307 53.9531 95.9922V63.7656H100.047V95.9922C100.047 96.5307 99.6088 96.9688 99.0703 96.9688H94.258L84.2934 87.0041C85.372 85.0324 85.9859 82.7718 85.9859 80.3702C85.9859 72.7238 79.7651 66.503 72.1188 66.503C64.4724 66.503 58.2516 72.7238 58.2516 80.3702C58.2516 88.0166 64.4724 94.2374 72.1188 94.2374C74.52 94.2374 76.7806 93.6235 78.7521 92.545L83.1758 96.9687H74.583C74.0438 96.9687 73.6064 97.406 73.6064 97.9452C73.6064 98.4845 74.0438 98.9218 74.583 98.9218H85.1289L89.0598 102.853C89.8235 103.617 90.827 103.998 91.8303 103.998C92.8336 103.998 93.837 103.617 94.6009 102.853C95.6628 101.791 95.9856 100.266 95.5713 98.9218H99.0703C100.686 98.9218 102 97.6075 102 95.9921V56.9296C102 55.3143 100.686 54 99.0703 54ZM60.2047 80.3702C60.2047 73.8008 65.5493 68.4562 72.1188 68.4562C78.6882 68.4562 84.0328 73.8008 84.0328 80.3702C84.0328 86.9396 78.6882 92.2843 72.1188 92.2843C65.5493 92.2843 60.2047 86.9397 60.2047 80.3702ZM83.2106 88.6837L85.0704 90.5435L82.2915 93.3224L80.4317 91.4626C81.4838 90.6721 82.4202 89.7356 83.2106 88.6837ZM93.2199 101.472C92.4536 102.238 91.207 102.238 90.4409 101.472L83.6727 94.7034L86.4516 91.9245L93.2198 98.6928C93.986 99.4589 93.986 100.705 93.2199 101.472ZM53.9531 61.8125V56.9297C53.9531 56.3912 54.3912 55.9531 54.9297 55.9531H99.0703C99.6088 55.9531 100.047 56.3912 100.047 56.9297V61.8125H53.9531Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75 57.9062H74.6562C74.117 57.9062 73.6797 58.3436 73.6797 58.8828C73.6797 59.4221 74.117 59.8594 74.6562 59.8594H95.75C96.2893 59.8594 96.7266 59.4221 96.7266 58.8828C96.7266 58.3436 96.2893 57.9062 95.75 57.9062Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5469 57.9062C62.29 57.9062 62.0381 58.0098 61.8564 58.1924C61.6747 58.374 61.5703 58.626 61.5703 58.8828C61.5703 59.1396 61.6747 59.3916 61.8564 59.5731C62.0381 59.7548 62.29 59.8594 62.5469 59.8594C62.8037 59.8594 63.0557 59.7549 63.2372 59.5731C63.4189 59.3916 63.5234 59.1396 63.5234 58.8828C63.5234 58.626 63.4189 58.374 63.2372 58.1924C63.0557 58.0097 62.8037 57.9062 62.5469 57.9062Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25 57.9062C57.9932 57.9062 57.7412 58.0098 57.5596 58.1924C57.3778 58.374 57.2734 58.626 57.2734 58.8828C57.2734 59.1396 57.3778 59.3916 57.5596 59.5731C57.7412 59.7548 57.9932 59.8594 58.25 59.8594C58.5068 59.8594 58.7588 59.7549 58.9403 59.5731C59.1221 59.3906 59.2266 59.1396 59.2266 58.8828C59.2266 58.626 59.1221 58.374 58.9403 58.1924C58.7588 58.0097 58.5068 57.9062 58.25 57.9062Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8438 57.9062C66.5869 57.9062 66.335 58.0098 66.1533 58.1924C65.9717 58.374 65.8672 58.626 65.8672 58.8828C65.8672 59.1396 65.9716 59.3916 66.1533 59.5731C66.335 59.7548 66.5869 59.8594 66.8438 59.8594C67.1006 59.8594 67.3525 59.7549 67.5341 59.5731C67.7158 59.3916 67.8203 59.1396 67.8203 58.8828C67.8203 58.626 67.7158 58.374 67.5341 58.1924C67.3525 58.0097 67.1006 57.9062 66.8438 57.9062Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1191 79.6875C71.5799 79.6875 71.1426 80.1248 71.1426 80.6641V84.4727C71.1426 85.0119 71.5799 85.4492 72.1191 85.4492C72.6584 85.4492 73.0957 85.0119 73.0957 84.4727V80.6641C73.0957 80.1248 72.6584 79.6875 72.1191 79.6875Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1191 75.293C71.8613 75.293 71.6094 75.3974 71.4277 75.5791C71.2462 75.7606 71.1426 76.0126 71.1426 76.2695C71.1426 76.5264 71.2462 76.7783 71.4277 76.9599C71.6094 77.1415 71.8613 77.2461 72.1191 77.2461C72.376 77.2461 72.6279 77.1416 72.8096 76.9599C72.9912 76.7783 73.0957 76.5264 73.0957 76.2695C73.0957 76.0126 72.9913 75.7606 72.8096 75.5791C72.6278 75.3974 72.3759 75.293 72.1191 75.293Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1191 70.4102C66.6267 70.4102 62.1582 74.8786 62.1582 80.3711C62.1582 85.8636 66.6267 90.332 72.1191 90.332C77.6116 90.332 82.0801 85.8636 82.0801 80.3711C82.0801 74.8786 77.6116 70.4102 72.1191 70.4102ZM72.1191 88.3789C67.7036 88.3789 64.1113 84.7866 64.1113 80.3711C64.1113 75.9556 67.7036 72.3633 72.1191 72.3633C76.5347 72.3633 80.127 75.9556 80.127 80.3711C80.127 84.7866 76.5346 88.3789 72.1191 88.3789Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.377 73.7305C87.377 74.2697 87.8143 74.707 88.3535 74.707H95.7492C96.2885 74.707 96.7258 74.2697 96.7258 73.7305C96.7258 73.1912 96.2885 72.7539 95.7492 72.7539H88.3535C87.8142 72.7539 87.377 73.1911 87.377 73.7305Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.355 68.0664H86.3496C85.8104 68.0664 85.373 68.5037 85.373 69.043C85.373 69.5822 85.8104 70.0195 86.3496 70.0195H88.355C88.8942 70.0195 89.3315 69.5822 89.3315 69.043C89.3315 68.5037 88.8942 68.0664 88.355 68.0664Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7492 70.0195C96.2885 70.0195 96.7258 69.5822 96.7258 69.043C96.7258 68.5037 96.2885 68.0664 95.7492 68.0664H92.6504C92.1111 68.0664 91.6738 68.5037 91.6738 69.043C91.6738 69.5822 92.1111 70.0195 92.6504 70.0195H95.7492Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.749 77.4414H93.332C92.7928 77.4414 92.3555 77.8787 92.3555 78.418C92.3555 78.9572 92.7928 79.3945 93.332 79.3945H95.749C96.2883 79.3945 96.7256 78.9572 96.7256 78.418C96.7256 77.8787 96.2883 77.4414 95.749 77.4414Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1875 96.9688C69.9307 96.9688 69.6787 97.0723 69.4971 97.2549C69.3154 97.4365 69.2109 97.6885 69.2109 97.9453C69.2109 98.2021 69.3153 98.4531 69.4971 98.6356C69.6787 98.8173 69.9307 98.9219 70.1875 98.9219C70.4443 98.9219 70.6963 98.8174 70.8778 98.6356C71.0595 98.4541 71.1641 98.2021 71.1641 97.9453C71.1641 97.6874 71.0596 97.4365 70.8778 97.2549C70.6963 97.0722 70.4443 96.9688 70.1875 96.9688Z",
    fill: "#1C3E77"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 28.5,
    width: 97,
    height: 97,
    rx: 48.5,
    stroke: "#FAFAFF",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171_6059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7672 42.2493C39.7146 42.2493 38.8112 41.983 38.0569 41.4503C37.3069 40.9134 36.7295 40.1399 36.3247 39.13C35.9241 38.1158 35.7238 36.8949 35.7238 35.4673C35.7281 34.0398 35.9305 32.8253 36.3311 31.8239C36.7359 30.8182 37.3133 30.0511 38.0633 29.5227C38.8176 28.9943 39.7189 28.7301 40.7672 28.7301C41.8155 28.7301 42.7167 28.9943 43.471 29.5227C44.2253 30.0511 44.8027 30.8182 45.2032 31.8239C45.6081 32.8295 45.8105 34.044 45.8105 35.4673C45.8105 36.8991 45.6081 38.1222 45.2032 39.1364C44.8027 40.1463 44.2253 40.9176 43.471 41.4503C42.721 41.983 41.8197 42.2493 40.7672 42.2493ZM40.7672 40.2486C41.5854 40.2486 42.2309 39.8459 42.704 39.0405C43.1812 38.2308 43.4199 37.0398 43.4199 35.4673C43.4199 34.4276 43.3112 33.554 43.0939 32.8466C42.8765 32.1392 42.5697 31.6065 42.1734 31.2486C41.7771 30.8864 41.3084 30.7053 40.7672 30.7053C39.9532 30.7053 39.3098 31.1101 38.8368 31.9197C38.3638 32.7251 38.1251 33.9077 38.1209 35.4673C38.1166 36.5114 38.221 37.3892 38.4341 38.1009C38.6514 38.8125 38.9582 39.3494 39.3545 39.7116C39.7508 40.0696 40.2217 40.2486 40.7672 40.2486ZM53.2588 28.9091V42H50.8874V31.2166H50.8107L47.7489 33.1726V30.9993L51.0024 28.9091H53.2588Z",
    fill: "#283476"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171_6059",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.243137 0 0 0 0 0.466667 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_6059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171_6059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_6059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(52 54)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutsec31);
export default __webpack_public_path__ + "static/media/aboutsec31.e0d58adb248ef6e24eab6255f9d56c99.svg";
export { ForwardRef as ReactComponent };